import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, Box, Modal, Typography } from '@mui/material' // ← make sure Modal is here
import { setLoader, setOpenTransportModal } from '../../../../../../../redux/globalSlice'
import classes from './AddNewStudentModal.module.css'
import Dropdown from '../../../../../../../common/Dropdown/Dropdown'
import { SelectField } from '../../../../../../../components'
import { useGlobal } from '../../../../../../../shared'
import { baseURL, urls } from '../../../../../../../shared/config'
import { highestInt } from '../../../../../../../shared/utils/constants'
import { warning, yellowWarning } from '../../../../../../../assets/icons'
import StudentBox from '../../../../../../../common/StudentBox/StudentBox'
import { SuccesAnimation } from '../../../../../../../assets/images'
import axios from 'axios'
import { toast } from 'react-toastify'

const AddNewStudentModal = ({ role, schoolList, userSchoolId, studentList, refetch }) => {
  const [step, setStep] = useState(1)
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: step === 4 ? 393 : 627,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '12px', // optional: looks better
  }

  //   const totalSteps = 4
  const [schoolName, setSchoolName] = React.useState('')
  const [className, setClassName] = useState('')
  const [vanId, setVanId] = useState('')
  const [vanRouteId, setVanRouteId] = useState('')
  const [stopeId, setStopId] = useState('')
  const [studentName, setStudentName] = useState(null)

  const open = useSelector((state) => state.global.openTransportModal)
  const dispatch = useDispatch()
  const handleClose = () => dispatch(setOpenTransportModal(false))

  const progressMap = {
    1: '50%',
    2: '100%',
  }
  const progress = progressMap[step] ?? '0%'
  const [selectedGrade, setSelectedGrade] = useState('')

  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${role == 'Admin' ? userSchoolId : schoolName}&page=1&limit=10000`,
  })

  const selectedGradeObj = grades?.find((g) => String(g.grade_id) === String(selectedGrade))

  const { data: studentRow } = useGlobal({
    userUrl: `${urls.STUDENT_LIST}school_id=${role == 'Admin' ? userSchoolId : schoolName}&page=${1}&limit=${highestInt}&section_id=${className}&grade_id=${selectedGrade}&van_facility=false`,
  })

  const { data: routeData } = useGlobal({
    userUrl: `${urls.ROUTE_GET}${role == 'Admin' ? userSchoolId : schoolName}&page=1&limit=50`,
  })

  const { data: stopData } = useGlobal({
    userUrl: `${urls.STOP_GET}${vanRouteId?.route_id}`,
  })
  const { data: vanData, count: vanCount } = useGlobal({
    userUrl: `${urls.VAN_GET}${role == 'Admin' ? userSchoolId : schoolName}&page=1&limit=1000`,
  })
  const handleNext = async () => {
    if (step === 1) {
      if (!selectedGrade) return alert('Please select a Grade')
      if (!className) return alert('Please select a Class')
      if (!studentName) return alert('Please select a Student')
      setStep(2)
      return
    }

    if (step === 2) {
      if (!vanRouteId) return alert('Please select a Route')
      if (!vanId) return alert('Please select a Van')
      setStep(3)
      return
    }

    if (step === 3) {
      // Simulate success (replace with real API call later)
      // console.log('Assigning student to van:', {
      //   studentId: studentName?.student_id,
      //   student: studentName?.student_name,
      //   vanId: vanId?.van_id,
      //   vanNumber: vanId?.van_number,
      //   route: vanRouteId?.route_name,
      // })
            dispatch(setLoader(false))
      try {
        const responseBody = {
          stop_id: stopeId,
          route_id: vanRouteId?.route_id,
          van_id: vanId?.van_id,
          student_id: studentName?.student_id,
          school_id: userSchoolId,
        }
        const response = await axios.post(`${baseURL}${urls.TRANSPORT_STUDENT_GET}`, responseBody)

        if (response?.data?.status === 200) {
          setStep(4)
        } else {
          toast.error('Error Adding Student, Please Try Again Later')
          handleClose()
        }
      } catch (error) {
        console.error('-----error adding student', error)
        toast.error('Error Adding Student, Please Try Again Later')
        handleClose()
      } finally {
        refetch()
        dispatch(setLoader(false))
      }
      return
    }

    if (step === 4) {
      handleClose()
    }
  }

  const handleBack = () => {
    if (step > 1) {
      setStep((prev) => prev - 1)
    }
  }

  //   console.log('----studentName', studentName)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={classes.container}>
          {step < 4 && (
            <div className="header-registration">
              <p className="modalheadtxt">Add New Student</p>
              <div className="linear-progress">
                <div className="linear-p-bar">
                  <div className="filled-area" style={{ width: progress }} />
                </div>
                <Typography>{step}/2</Typography>{' '}
                {/* keep showing /3 or change to /4 if preferred */}
              </div>
            </div>
          )}
        </div>
        {step !== 3 && step !== 4 && role != 'Admin' && (
          <SelectField
            placeholder={'Select School'}
            options={(schoolList || [])?.map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            name="schoolName"
            value={schoolName}
            onChange={(selectedOption) => setSchoolName(selectedOption)}
            width={'100%'}
          />
        )}

        {/* Step content */}
        {step === 1 ? (
          <>
            <div className={classes.grid}>
              <SelectField
                placeholder={'Select'}
                options={grades?.map((m) => ({
                  value: m?.grade_id,
                  label: m?.grade,
                }))}
                value={selectedGrade}
                onChange={(selectedOption) => setSelectedGrade(selectedOption)}
                label={'Grade'}
                required={true}
                width={'100%'}
              />
              <SelectField
                placeholder={'Select'}
                options={selectedGradeObj?.grade_sections?.map((m) => ({
                  value: m?.section_id,
                  label: m?.section,
                }))}
                value={className}
                onChange={(selectedOption) => setClassName(selectedOption)}
                label={'Class'}
                required={true}
                width={'100%'}
              />
            </div>
            <SelectField
              placeholder={'Select'}
              options={studentRow?.map((m) => ({
                value: m,
                label: m?.student_name,
              }))}
              value={studentName}
              onChange={(selectedOption) => setStudentName(selectedOption)}
              label={'Student List'}
              required={true}
              width={'100%'}
            />
          </>
        ) : step === 2 ? (
          <div className={classes.box}>
            {/* Route selection – fixed wrong state usage */}
            <SelectField
              placeholder="Select"
              options={
                routeData?.map((m) => ({
                  value: m,
                  label: m?.route_name,
                })) || []
              }
              value={vanRouteId || ''} // ← you probably want separate state for route
              onChange={(selectedOption) => {
                setVanRouteId(selectedOption) // new state you'll need to add
                setVanId(null) // reset van when route changes
              }}
              label="Route"
              required={true}
              width="100%"
            />
            <SelectField
              placeholder="Select"
              options={
                stopData?.map((m) => ({
                  value: m,
                  label: `${m?.stop_address},${m?.stop_address_two},${m?.stop_city},${m?.stop_state},${m?.stop_pincode}`,
                })) || []
              }
              value={stopeId || ''} // ← you probably want separate state for route
              onChange={(selectedOption) => {
                setStopId(selectedOption) // new state you'll need to add// reset van when route changes
              }}
              label="Stops"
              required={true}
              width="100%"
            />

            <div className={classes.vanbox}>
              <div className={classes.topnox}>
                <p className={classes.vanTitle}>Vans</p>
                <p className={classes.vanCount}>{vanCount || 0}</p>
              </div>

              <div className={classes.vanlist}>
                {vanData?.length === 0 ? (
                  <p style={{ color: '#888', textAlign: 'center', padding: '20px 0' }}>
                    No vans found for this route/school
                  </p>
                ) : (
                  vanData?.map((item) => {
                    const isSelected = vanId?.van_id === item?.van_id

                    return (
                      <div
                        key={item?.van_id}
                        className={`${classes.vanItem} ${isSelected ? classes.selectedVan : ''}`}
                      >
                        <p className={classes.routename}>
                          {item?.employee_name || '—'} , <span>{item?.van_number || '—'}</span> ,{' '}
                          <span className={classes.subttx}>
                            {item?.student_count || 0}/{item?.van_size || '?'}
                          </span>
                        </p>

                        <button
                          type="button"
                          className={`${classes.select} ${isSelected ? classes.selected : ''}`}
                          onClick={() => setVanId(item)}
                        >
                          {isSelected ? 'Selected' : 'Select'}
                        </button>
                      </div>
                    )
                  })
                )}
              </div>
            </div>
          </div>
        ) : step === 3 ? (
          <div className={classes.confirmationBox}>
            <img src={yellowWarning} alt="Warning Icon" className={classes.warningIcon} />
            <p className={classes.headtxt}>
              Are you Sure you want to add this student to transport list
            </p>
            <p className={classes.subtxt}>
              This will change the fee structure for the student and lets them use the Van Facilty{' '}
            </p>
            <div className={`${classes.vanbox} ${classes.gap}`}>
              <div className={classes.vanItem}>
                <p className={classes.title}>Admission Number</p>
                <p className={classes.sutitle}>{studentName?.student_id}</p>
              </div>
              {/* <hr className={classes.rule} /> */}
              <StudentBox
                student_avatar={studentName?.student_avatar}
                student_name={studentName?.student_name}
                student_grade={studentName?.student_grade}
                student_section={studentName?.student_section}
              />
            </div>
            <div className={`${classes.vanbox} ${classes.gap}`}>
              <p className={classes.vansubtitle}>Van Information</p>
              <div className={classes.vanbottom}>
                <div className={classes.vansubbox}>
                  <p className={classes.vansub}>Van Number</p>
                  <p className={classes.sutitle}>{vanId?.van_number || '—'}</p>
                </div>
                <hr className={classes.vertRule} />
                <div className={classes.vansubbox}>
                  <p className={classes.vansub}>Driver</p>
                  <p className={classes.sutitle}>
                    {vanId?.employee_name || vanId?.driver_name || '—'}
                  </p>
                </div>
                <hr className={classes.vertRule} />
                <div className={classes.vansubbox}>
                  <p className={classes.vansub}>Route</p>
                  <p className={classes.routetxt}>
                    {vanRouteId?.route_name || vanId?.route_name || '—'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ) : step === 4 ? (
          <div className={classes.confirmationBox}>
            <img src={SuccesAnimation} alt="Success Icon" className={classes.warningIcon} />
            <p className={classes.headtxt}>Student Added!</p>
            <p className={classes.subtxt}>This student can now use the van facility</p>
          </div>
        ) : (
          <div>Invalid step</div>
        )}
        <div className={classes.bottom}>
          {step !== 4 && (
            <button
              onClick={() => {
                if (step === 3) {
                  handleBack() // "No" → back to van selection
                } else {
                  handleClose()
                }
              }}
              className="white-button"
            >
              {step === 3 ? 'No, Cancel and Go back' : 'Cancel'}
            </button>
          )}

          <button
            onClick={handleNext}
            className={`${step === 4 ? classes.flex : ''} primary-button`}
          >
            {step === 4 ? 'Okay' : step === 3 ? 'Yes, I am Sure' : 'Add'}
          </button>
        </div>
      </Box>
    </Modal>
  )
}

export default AddNewStudentModal
